/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const GET_CHECKOUT_PROPERTIES = 'GET_CHECKOUT_PROPERTIES';
export const LOAD_CHECKOUT_PROPERTIES = 'LOAD_CHECKOUT_PROPERTIES';
